import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResultGetPaged } from 'pmv-common';
import { Avaliacao } from '../models/avaliacao.model';
import { AvaliacaoFilter } from '../models/avaliacao-filter';

@Injectable()
export class AvaliacaoService {

  constructor(private httpClient: HttpClient) { }

  GetAvaliacoes(page?: number, itemsPerPage?: number, filter?: AvaliacaoFilter): Observable<ResultGetPaged<Avaliacao>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Avaliacao>>('/Avaliacao/GetAvaliacoes', filter);
  }

  Delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`/Avaliacao/DeleteAvaliacoes/${id}`);
  }
  
}




// WEBPACK FOOTER //
// ./src/app/services/avaliacao.service.ts